import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";

import Layout from "./components/Layout/Layout";
import ScrollToTop from "./components/Layout/ScrollToType";

// General
const Home = lazy(() => import("./home"));
const SearchResults = lazy(() => import("./components/search/results"));
const Organizations = lazy(() => import("./components/organisations"));

// Publications
const PublicationsIndexes = lazy(() => import("./components/publications/index"));
const PublicationsSubIndexes = lazy(() => import("./components/publications/subindex"));
const PublicationsNode = lazy(() => import("./components/publications/node"));

// Blogs
const BlogsIndexes = lazy(() => import("./components/blogs/index"));
const BlogsSubIndexes = lazy(() => import("./components/blogs/subindex"));
const BlogsNode = lazy(() => import("./components/blogs/node"));

// Resources
const ResourcesIndexes = lazy(() => import("./components/resources/index"));
const ResourcesSubIndexes = lazy(() => import("./components/resources/subindex"));
const ResourcesNode = lazy(() => import("./components/resources/node"));

// Projects
const ProjectsIndexes = lazy(() => import("./components/projects/index"));
const ProjectsSubIndexes = lazy(() => import("./components/projects/subindex"));
const ProjectsNode = lazy(() => import("./components/projects/node"));

// Research Briefings
const ResearchBriefingsIndexes = lazy(() => import("./components/research-briefings/index"));
const ResearchBriefingsSubIndexes = lazy(() => import("./components/research-briefings/subindex"));
const ResearchBriefingsNode = lazy(() => import("./components/research-briefings/node"));

// Fire Australia
const FireAustraliaIndexes = lazy(() => import("./components/fireaustralia/index"));
// const FireAustraliaSubIndexes = lazy(() => import("./components/fireaustralia/subindex"));
const FireAustraliaNode = lazy(() => import("./components/fireaustralia/node"));

function App() {
  return (
    <Router>
      <Layout>
        <ScrollToTop />
        <Suspense fallback={<div className="p-8 text-center">Loading...</div>}>
          <Routes>
            {/* Home & General */}
            <Route path="/" element={<Home />} />
            <Route path="/results" element={<SearchResults location={location} />}/>
            <Route path="/organisations" element={<Organizations />} />

            {/* Publications */}
            <Route path="/publications" element={<PublicationsIndexes />} />
            <Route path="/publications/subindex" element={<PublicationsSubIndexes />} />
            <Route path="/publications/node" element={<PublicationsNode />} />

            {/* Blogs */}
            <Route path="/blogs" element={<BlogsIndexes />} />
            <Route path="/blogs/subindex" element={<BlogsSubIndexes />} />
            <Route path="/blogs/node" element={<BlogsNode />} />

            {/* Resources */}
            <Route path="/resources" element={<ResourcesIndexes />} />
            <Route path="/resources/subindex" element={<ResourcesSubIndexes />} />
            <Route path="/resources/node" element={<ResourcesNode />} />

            {/* Projects */}
            <Route path="/projects" element={<ProjectsIndexes />} />
            <Route path="/projects/subindex" element={<ProjectsSubIndexes />} />
            <Route path="/projects/node" element={<ProjectsNode />} />

            {/* Research Briefings */}
            <Route path="/research-briefings" element={<ResearchBriefingsIndexes />} />
            <Route path="/research-briefings/subindex" element={<ResearchBriefingsSubIndexes />} />
            <Route path="/research-briefings/node" element={<ResearchBriefingsNode />} />

            {/* Fire Australia */}
            <Route path="/fireaustralia" element={<FireAustraliaIndexes />} />
            {/* <Route path="/fireaustralia/subindex" element={<FireAustraliaSubIndexes />} /> */}
            <Route path="/fireaustralia/node" element={<FireAustraliaNode />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;
